import { toUrlSafe } from 'utils/stringHelpers'
import { getSlug } from 'pages/Lessons/utils'

/**
 * Generate course instance path based on tier and other parameters
 * @param {Object} params - Course instance path parameters
 * @param {string} params.program - The program identifier
 * @param {string} params.gradeDisplayTitle - The grade display title
 * @param {string} params.instance - The instance identifier
 * @param {number} [params.tier=1] - The tier level (1 or 2)
 * @param {string} [params.defaultUnit=''] - The default unit slug for tier 2 courses
 * @returns {string} The course instance path
 */
export const getCourseInstancePath = ({
  program,
  gradeDisplayTitle,
  instance,
  tier = 1,
  defaultUnit = '',
}) => {
  const urlFragment = instance ? toUrlSafe(String(instance)) : ''
  // Ensure we always operate on a string title
  const safeTitle =
    typeof gradeDisplayTitle === 'string'
      ? gradeDisplayTitle
      : String(gradeDisplayTitle || '')

  if (tier === 1) {
    // Tier 1: Keep existing behavior
    return `/product/${program}/lessons/teach/${getSlug(
      safeTitle,
    )}?class=${urlFragment}`
  } else if (tier === 2) {
    // Tier 2: Handle pluralization for Grade X-X format and add tier-2 in path
    let modifiedGradeTitle = safeTitle

    // Check if the title starts with "Grade" and pluralize it
    if (safeTitle && safeTitle.toLowerCase().startsWith('grade ')) {
      modifiedGradeTitle = safeTitle.replace(/^Grade /i, 'Grades ')
    }

    // !!! TODO: we should dynamically infer the default unit instead of hardcoding it in productMaps !!!
    return `/product/${program}/lessons/tier-2/teach/${getSlug(
      modifiedGradeTitle,
    )}/${defaultUnit}?class=${urlFragment}`
  }

  // Default to tier 1 behavior for any other tier values
  return `/product/${program}/lessons/teach/${getSlug(
    safeTitle,
  )}?class=${urlFragment}`
}
